<template>
  <div class="sider-container">
    <div @click="silderCut" class="menuBox" :class="isCollapse ? 'menuBoxClose' : ''">
      <a href="javascript:;">
        <img src="../assets/img/icon-menu.png" :class="{ shouqi: !isCollapse }" />
      </a>
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      :class="isCollapse ? 'closeSilderBox' : 'closeSilderBoxB'"
      :default-openeds="isCollapse ? openedsNull : openeds"
      :collapse="true"
      @open="handleOpen"
      @close="handleClose"
    >
      <div v-for="(item) in silderList" :key="item.path + item.id">
        <el-submenu :index="item.id" :class="isCollapse ? 'closeSilder' : ''">
          <template slot="title">
            <img :src="getImg(item.meta.icon)" class="silderIcon" :class="isCollapse ? 'mt10' : ''" />
            <span>{{item.meta.title}}</span>
          </template>
          <el-menu-item
            v-for="(child) in item.children"
            :index="child.name"
            :key="child.path + child.id"
            @click="handlechildren(child)"
            class="subItem"
            v-show="IsHavePayPlan == 1 ? true : !payMenuList.includes(child.meta.title)"
          >
            {{child.meta.title}}
          </el-menu-item>
        </el-submenu>
        <!-- <el-menu-item 
          v-if="item.noShowingChildren"
          :index="item.children[0].name"
          @click="handlechildren(item)"
          class="menuTitle"
          :class="isCollapse ? 'closeSilder' : ''"
        >
          <img
            :src="getImg(item.meta.icon)"
            class="silderIcon"
            :class="isCollapse ? 'mt10' : ''"
          />
          <span slot="title">{{item.meta.title}}1</span>
          <span slot="title">{{item.meta.title}}</span>
          <span :class="isCollapse ? 'itemTitle' : 'none'">{{ item.meta.title }}11</span>
        </el-menu-item>

        <el-submenu v-else :index="item.id" :class="isCollapse ? 'closeSilder' : ''">
          <template slot="title">
            <img :src="getImg(item.meta.icon)" class="silderIcon" :class="isCollapse ? 'mt10' : ''" />
            <span>{{item.meta.title}}</span>
          </template>

          <el-menu-item 
            v-for="(child) in item.children"
            :index="child.name"
            :key="child.path + child.id"
            @click="handlechildren(child)"
            class="subItem"
            v-show="needPayment == 1 ? true : !payMenuList.includes(child.meta.title)"
          >
            {{child.meta.title}}
          </el-menu-item>
          
        </el-submenu> -->
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {judgeIsPay} from "@/http/modules/home.js"
export default {
  name: "out-sider",
  props: ['needPayment'],
  data() {
    return {
      menuIdList: [],
      openedsNull: [],
      openeds: ["1", "2", "3", "4", "5", "6", "7", "8"],
      // payMenuList: ['缴费管理', '缴费订单']
            // 是否有批次开启缴费
      IsHavePayPlan: 0,
      // 缴费管理,缴费订单 菜单
      payMenuList: ['缴费管理', '缴费订单']
    };
  },
  computed: {
    ...mapGetters(['sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    },
    silderList() {
      return this.$store.getters.showRoutes
    },
    getTips() {
      return !this.isCollapse ? "收起" : "展开";
    },
    activeIndex() {
      return this.$route.name
    },
    defaultPath() {
      return this.$route.path;
    },
    noChildrenSilderList() {
      return this.silderList.filter((item) => item.noShowingChildren);
    },
    hasChildrenSilderList() {
      return this.silderList.filter((item) => !item.noShowingChildren);
    },
  },
  mounted(){
    this.isOpenPay();
  },
  methods: {
    // 是否有批次开启缴费
    isOpenPay() {
      judgeIsPay().then( ({data}) => {
        this.IsHavePayPlan = data;
        this.$store.commit('setAdminMenu', data);
      })
    },
    getImg(icon) {
      if (icon) {
        return require(`../assets/img/${icon}`)
      } else {
        return require(`../assets/img/setting-icon.png`)
      }
    },
    silderCut() {
      this.$store.dispatch('app/toggleSideBar')
    },
    handleOpen(index) {},
    handleClose(index) {},
    handlechildren(item) {
      const { name } = item
      this.$router.push({ name });
    },
    getMenuId(id) {
      return this.menuIdList.includes(id);
    },
  },
};
</script>

<style lang="less" scoped>
.sider-container {
  position: relative;
  height: 100%;
  margin-left: 24px;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  .el-menu {
    height: 100%;
    border-right: 8px;
  }
}
.el-menu-vertical-demo {
  padding-top: 42px;
  border-radius: 8px;
  box-sizing: border-box;
  // box-shadow: 0px 0px 8px 2px #006aff;
}


// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   width: 192px;
//   overflow-x: hidden;
//   overflow-y: auto;
// }
.el-menu-vertical-demo .li {
  transition: all 0.3s linear;
}
.el-menu-vertical-demo .el-menu-item.subItem {
  color: #737780;
}

// /deep/ .el-menu--collapse {
//     width: 80px;
//     width: 192px; 
// }

.el-menu-item.subItem {
  border-left: 3px transparent solid;
  height: 40px !important;
  line-height: 40px !important;
  padding-left: 50px !important;
  text-align: left;
  min-width: none !important;
  font-size: 13px;
  color: #9299a6;
}
.el-menu-item.subItem:focus,
.el-menu-item.subItem:hover,
.el-menu-item.subItem.is-active {
  outline: 0;
  background-color: #ebf5ff;
  border-left: 3px #006aff solid;
  color: #006aff;
  font-size: 14px;
  font-weight: 600;
}
.el-menu--popup-right-start .el-menu-item.subItem{
  padding-left: 20px !important;
}
.el-menu--popup-right-start .el-menu-item.subItem:focus,
.el-menu--popup-right-start .el-menu-item.subItem:hover,
.el-menu--popup-right-start .el-menu-item.subItem.is-active {
  outline: 0;
  background-color: #ebf5ff;
  border-left: 3px transparent solid;
  color: #006aff;
  font-size: 13px;
  font-weight: 400;
}
/* 菜单箭头 */
/deep/ .el-submenu__icon-arrow {
  text-align: center;
  /* 已经物理垂直居中 , 加上后视觉居中 */
  line-height: 20px;
}
.closeSilder /deep/ .el-submenu__icon-arrow {
  display: none;
}

// 菜单标题
.menuTitle,
/deep/ .el-submenu__title {
  font-size: 16px;
  color: #3d3e40;
  padding: 0 15px 0 25px !important;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  font-weight: 600;
  height: 40px;
  line-height: 40px;
  margin: 12px 0;
}
.menuTitle {
  // border-left: none;
  // 一级单菜单用到
  /deep/ .el-tooltip {
    display: flex !important;
    justify-content: center;
  }
  .itemTitle {
    position: absolute;
    font-size: 14px;
    font-weight: 400;
    top: 30px;
    color: #737780;
    left:50%;
    transform: translateX(-50%);
  }
}
/* 首页导航栏位置（收起） */
.closeSilder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.closeSilder.menuTitle {
  border-radius: 4px;
  height: 60px;
  width:64px;
  margin-left:8px;
}
.closeSilder /deep/ .el-submenu__title {
  width:64px;
  text-align: center;
  margin-bottom: 12px;
  margin-top: 0;
  font-size: 13px;
  color:#737780;
  height: 60px;
  line-height: 60px;
  font-weight: 400;
}
/deep/ .el-menu--collapse  .el-menu-item span,
/deep/ .el-menu--collapse  .el-submenu > .el-submenu__title span {
  height: 30px;
  line-height: 30px;
  width: auto;
  overflow: auto;
  visibility: inherit;
}
.closeSilderBox {
  width: 80px;
  padding-top: 52px;
  box-sizing: border-box;
  .menuBox {
    padding: 0 8px !important;
  }
}
.closeSilderBoxB {
  width: 192px;
}
.closeSilder {
  /deep/ .el-submenu__title {
    padding: 0 8px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-submenu__title:hover {
    background: #f1f2f5;
    border-radius: 4px;
  }
}
/* 首页 */
.closeSilder.menuTitle:hover {
  background: #f1f2f5;
}
.menuBox {
  position: absolute;
  // top:24px;
  top: 26px;
  right: 14px;
  z-index: 1111;
  a {
    float: right;
    display: block;
    height: 16px;
    img.shouqi {
      transform: rotateY(180deg);
    }
  }
}
.menuBoxClose.menuBox{
  right: 32px;
}
/* 一级分类 icon */
.silderIcon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.closeSilder {
  .silderIcon {
    display: block;
    margin-right: 0;
  }
}
</style>

